import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import RibbonBar from "./components/RibbonBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ChannelExecutions from "./components/ChannelExecutions";
import Campaigns from "./components/Campaigns";
import Industries from "./components/Industries";
import Pricing from "./components/Pricing";
import Teammate from "./components/Teammate";
import Footer from "./components/Footer";
import About from "./pages/About";
import GetStarted from "./pages/GetStarted";
import AdminOnboarding from "./pages/AdminOnboarding";
import AuthCallback from "./pages/AuthCallback";
import { smoothScrollToId } from "./lib/smoothScroll";

/** Scrolls to a hash target on route change, using the shared smooth-scroll helper. */
function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Auth callback owns its own hash — leave it alone.
    if (hash?.includes("session_id=")) return undefined;
    if (hash) {
      const id = hash.slice(1);
      const t = setTimeout(() => smoothScrollToId(id), 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    return undefined;
  }, [pathname, hash]);
  return null;
}

function Landing() {
  return (
    <main id="main">
      <Hero />
      <Campaigns />
      <ChannelExecutions />
      <Teammate />
      <Industries />
      <Pricing />
    </main>
  );
}

/**
 * Layout switcher.
 * - Marketing chrome (RibbonBar/Navbar/Footer) for `/`, `/about`, `/get-started`.
 * - Bare layout for admin routes.
 * - OAuth callback route hijacks rendering when the URL has `#session_id=`.
 */
function Shell() {
  const location = useLocation();

  // OAuth return — process BEFORE any auth check anywhere else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <div className="App noise-bg" style={{ minHeight: "100vh" }}>
        <ScrollManager />
        <Routes>
          <Route path="/admin/onboarding" element={<AdminOnboarding />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="App noise-bg">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:bg-[#6B4BEF] focus:text-white focus:px-3 focus:py-2 focus:rounded">
        Skip to main content
      </a>
      <RibbonBar />
      <Navbar />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/get-started" element={<GetStarted />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
